import { LanguageSwitcher } from '~/shared/ui/language-switcher'
import { ThemeToggle } from '~/shared/ui/theme-toggle'

export function AuthControlPanel() {
  return (
    <div className="absolute top-4 right-4 flex items-center gap-2 z-10">
      <LanguageSwitcher />
      <ThemeToggle />
    </div>
  )
}
